import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import {useLoginByPhoneContext} from '../LoginByPhoneContext';

const FieldCode = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'login-by-phone-form-code',
    defaultMessage: 'Code'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField<string>({name: 'code'});
  const {gotCode} = useLoginByPhoneContext();

  return gotCode
    ? (
      <InputText
        {...field}
        {...meta}
        type={'password'}
        variant={'full'}
        id={field.name}
        label={labelText}
        defaultValue={field.value}
        placeholder={placeholder}
        autoComplete={'off'}
      />
    )
    : null;
};

export default FieldCode;
